import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import axios from "axios";

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
// import {  Card, Col } from "reactstrap";
import "../css/course-blog.css";
const regex = /(<([^>]+)>)/ig; // for converting html raw data
const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
    paritialVisibilityGutter: 260,
    slidesToSlide: 1 // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 550 },
    items: 1,
    paritialVisibilityGutter: 30,
    slidesToSlide: 1 // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 550, min: 0 },
    items: 1,
    paritialVisibilityGutter: 30,
    slidesToSlide: 1 // optional, default to 1.
  }
};

class Blog extends Component {
  constructor(props) {
    super(props);
    const allblogs = [];
    // const thumbnails = [];
    
   
    this.state = {
      allblogs,
    };
  }

  componentDidMount() {
    this.getblogdetails();
  }

  async getblogdetails() {
    console.log(" in getblogdetails");

    axios
      .post("Login/allblogList")
      .then((res) => {
        if (res.data.status === "200") {
          console.log("res.data====  " + res.data.allblogs);
          // console.log("res.thumbnails ====  " +res.data.allblogs.title)
          this.setState({
            allblogs: res.data.allblogs,
          });

          return res;
        }
        throw res;
      })
      .catch((error) => {
        console.log("error123", error);
      });
  }

  render() {
    return (
      <div>
        <div aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <Link>
                <FontAwesomeIcon icon={faHome} /> &nbsp; HOME
              </Link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Blog
            </li>
          </ol>
        </div>

        <Carousel
                      responsive={responsive}
                    infinite={false}
                      autoPlaySpeed={5000}
                      containerClass="first-carousel-container container"
                    >
                      {this.state.allblogs.map((item) => (
                           <div>   
                             {item.thumbnails  ?
                             <img  alt=""  key={item.thumbnails[2]}
                                          src={item.thumbnails[2]}  width="100%" height="400px"/> 
                                          : 
                                          <img  alt=""  key=""
                                          src="/assets/images/eduplusnow.png"   width="100%" height="400px"/>   
                                          
                                          }                            
                                    
                                     <Link
                                    to={{
                                      pathname:"/blog/" + item.slug,
                                       params: { courseid: item.id },
                                    }}
                                  >
                                    <button
                                      color="primary"
                                      style={{ borderRadius: 50 }}
                                      className=" btn btn-getstarteds"
                                    >
                                      Read More
                                </button>
                                  </Link>
                                    
                                   
                               </div>
                              

                        
                      ))}
                    </Carousel>


       

        <div class="theia-exception mm-page mm-slideout" id="page">
          <div class="shadow-box padding-default ">
            <ul class="startcourse-horizontal-menu mobile-menu">
              <li> {
                  // eslint-disable-next-line
                }<a
                  class="hov"
                  id="category1"
                  onclick="document.getElementById('lstart').submit();"
                  href="#"
                >
                  {" "}
                  ALL{" "}
                </a>
                <form name="lstart" id="lstart" action="/blog" method="post">
                  <input
                    name="category"
                    id="category"
                    type="hidden"
                    value="ALL"
                  />
                </form>
              </li>
              <li>{
                  // eslint-disable-next-line
                }<a
                  class="hov"
                  id="category1"
                  onclick="document.getElementById('tech').submit();"
                  href="#"
                >
                  {" "}
                  Technology{" "}
                </a>
                <form name="tech" id="tech" action="/blog" method="post">
                  <input
                    name="category"
                    id="category"
                    type="hidden"
                    value="technology"
                  />
                </form>
              </li>
              <li>{
                  // eslint-disable-next-line
                }<a
                  class="hov"
                  id="category1"
                  onclick="document.getElementById('finance').submit();"
                  href="#"
                >
                  {" "}
                  Finance{" "}
                </a>
                <form name="finance" id="finance" action="/blog" method="post">
                  <input
                    name="category"
                    id="category"
                    type="hidden"
                    value="finance"
                  />
                </form>
              </li>
              <li>{
                  // eslint-disable-next-line
                }<a
                  class="hov"
                  id="category1"
                  onclick="document.getElementById('Careers').submit();"
                  href="#"
                >
                  {" "}
                  Careers{" "}
                </a>
                <form name="Careers" id="Careers" action="/blog" method="post">
                  <input
                    name="category"
                    id="category"
                    type="hidden"
                    value="careers"
                  />
                </form>
              </li>
              <li> {
                  // eslint-disable-next-line
                }<a
                  class="hov"
                  id="category1"
                  onclick="document.getElementById('Marketing').submit();"
                  href="#"
                >
                  {" "}
                  Marketing{" "}
                </a>
                <form
                  name="Marketing"
                  id="Marketing"
                  action="/blog"
                  method="post"
                >
                  <input
                    name="category"
                    id="category"
                    type="hidden"
                    value="marketing"
                  />
                </form>
              </li>
              <li>
                {
                  // eslint-disable-next-line
                }<a
                  class="hov"
                  id="category1"
                  onclick="document.getElementById('Law').submit();"
                  href="#"
                >Law
                </a>
                <form name="Law" id="Law" action="/blog" method="post">
                  <input
                    name="category"
                    id="category"
                    type="hidden"
                    value="law"
                  />
                </form>
              </li>
            </ul>
          </div>
        </div>
        <br />
        <br />
        <div class="padding-default" >
        <div class="row ">
          {this.state.allblogs.map((item) =>
               
                  <div class=" col-md-6 col-sm-8 col-lg-4 mar-box " >
                    <div class="box_grid">
                     
                        
                           {item.thumbnails ?
                           <>
                            <figure>
                           <Link
                           to={{
                             pathname:"/blog/" + item.slug,
                              params: { courseid: item.id },
                           }}
                         >
                           <img
                   
                   key={item.thumbnails[1]}
                   src={item.thumbnails[1]}
                   class="card-image"
                   alt="..."
                 />
                         </Link>

                         </figure>
                         </>
                          : 
                          <>
                          <figure>
                          <Link
                          to={{
                            pathname:"/blog/" + item.slug,
                             params: { courseid: item.id },
                          }}
                        >
                          <img
                  
                  key=""
                  src="/assets/images/eduplusnow.png" 
                  class="card-image"
                  alt="..."
                />
                        </Link>
                          </figure>
                          </>
                        }
                       
                    

                      <div class="wrapper" min-height="175px;">
                        <a href="blog">
                          <h5 class="card-title">{item.title}</h5>
                        </a>
                        <p>
                          <span class="fourLineparagraph"> {item.excerpt.replace(regex, '')}</span>
                        </p>
                      </div>
                      <hr />
                      <ul class="blog-ul list-group list-group-flush">
                        <li>
                          <span>
                            <i class="fa fa-calendar" aria-hidden="true"></i>
                          </span>
                          &nbsp; {item.date}
                        </li>
                      </ul>
                    </div>
                  </div>
                
          )}
        </div>
        </div>
      </div>
    );
  }
}

export default Blog;
